module.exports = __webpack_public_path__ + "img/reduce_btn@3x.4a9fcb70.png";